import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import {
  ConnectionsSelectors,
  CreateBotConnection,
  RemoveBotConnection,
  UpdateBotConnection,
} from 'projects/brn-frontend/src/app/core/store/bot-connections';

@Component({
  selector: 'brn-textmagic-connection-modal',
  templateUrl: './textmagic-connection-modal.component.html',
  styleUrls: ['./textmagic-connection-modal.component.scss']
})
export class TextmagicConnectionModalComponent implements OnInit {

  @ViewSelectSnapshot(ConnectionsSelectors.pendingStatus)
  pendingStatus!: boolean;

  newConnection = true;

  textmagicForm = this.formBuilder.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
    phone: ['', Validators.required],
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<TextmagicConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.providerData) {
      const providerData = data.providerData;
      this.newConnection = false;
      this.textmagicForm.patchValue(providerData);
    }
  }

  ngOnInit(): void {}

  get validForm(): boolean {
    return this.textmagicForm.valid;
  }

  createConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.textmagicForm.value;
    this.store.dispatch(new CreateBotConnection('textmagic', providerData));
  }

  updateConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.textmagicForm.value;
    this.store.dispatch(new UpdateBotConnection('textmagic', providerData));
  }

  removeConnection(): void {
    if (this.pendingStatus) {
      return;
    }
    this.store.dispatch(new RemoveBotConnection('textmagic'));
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
